import store from '../store'

export function displayNotification (response) {
    console.log(response)
    let message = ''
    let type = 'success'
    
    if (response.status >= 400) {
        type = 'error'
        message = response.data.errors ? response.data.errors : [[response.data.message]]
    } else if (response.status >= 200) {
        type = 'success'
        message = response.data.message ? response.data.message : 'Sucesso'
    }
    store.dispatch('notify/addNotification', { type: type, message: message }, { root: true })
}
